/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable object-shorthand */
import { Image, Linking, StyleSheet, TouchableOpacity, useWindowDimensions, ViewStyle } from 'react-native';
import React from 'react';
import { TextWrap as Text, View, styles as sc } from '../../components/Themed';
import { RootStackScreenProps } from '../../navigation/navigationTypes';
// Image assets
import SnapCalorieSitePage from '../../components/SnapCalorieSitePage';

const AppleAppstoreIconPng = require('../../../assets/images/AppleAppstoreDownload.png');
const AndroidAppstoreIconPng = require('../../../assets/images/AndroidAppstoreDownload.png');

type BorderedBoxPropsType = {
  title?: string;
  borderColor?: string;
  children?: React.ReactNode;
  style?: ViewStyle;
};
export function BorderedBox(props: BorderedBoxPropsType) {
  return (
    <View
      style={[
        {
          backgroundColor: props.borderColor ?? 'white',
          padding: 2,
          borderRadius: 5,
          borderColor: props.borderColor ?? '#ccc',
          borderWidth: 2,
          shadowColor: '#ccc',
          shadowOffset: { height: 4, width: 4 },
          shadowOpacity: 0.6,
        },
        props.style,
      ]}
    >
      {props.title && (
        <Text style={[sc.blockParagraph, { minHeight: 50, fontSize: 18, fontWeight: '800', color: '#000' }]}>
          {props.title}
        </Text>
      )}
      <View
        style={[
          {
            flex: 1,
            flexDirection: 'column',
            backgroundColor: '#fff',
          },
        ]}
      >
        {props.children}
      </View>
    </View>
  );
}
BorderedBox.defaultProps = {
  style: {},
  borderColor: null,
  title: null,
  children: {},
};

type DownloadOptionsProps = {
  maxWidth: number;
};

export function DownloadOptions(props: DownloadOptionsProps): JSX.Element {
  const windowDimensions = useWindowDimensions();
  return (
    <>
      <Text style={[sc.focusText, { fontSize: 20, textAlign: 'center', maxWidth: props.maxWidth, marginTop: 0 }]}>
        Download the app from the App Store and log in with your email address and password.
      </Text>
      <TouchableOpacity
        onPress={() => {
          Linking.openURL('https://apps.apple.com/us/app/snapcalorie-nutrition-tracker/id1574239307');
        }}
      >
        <Image
          source={AppleAppstoreIconPng}
          style={{
            marginTop: 40,
            marginBottom: 20,
            height: 40 * 1.5,
            width: 135 * 1.5,
            alignSelf: 'center',
          }}
        />
      </TouchableOpacity>
      <TouchableOpacity
        onPress={() => {
          Linking.openURL('https://play.google.com/store/apps/details?id=com.snapcalorie.alpha002');
        }}
      >      
        <Image
        source={AndroidAppstoreIconPng}
        style={{
          marginTop: 20,
          marginBottom: 40,
          height: 40 * 1.5,
          width: 135 * 1.5,
          alignSelf: 'center',
        }}
      />
      </TouchableOpacity>      
      <View
        style={{
          maxWidth: props.maxWidth,
          alignSelf: 'center',
        }}
        key="ContainerView"
      >
        <Text style={[sc.focusText, { fontSize: 16, textAlign: 'center' }]}>
          If you encounter problems installing or logging in to the SnapCalorie App on your device, contact us at:
        </Text>
        <Text style={[sc.link, { marginTop: 0 }]}>
          <a href="mailto:help@snapcalorie.com">help@snapcalorie.com</a>
        </Text>
      </View>
    </>
  );
}

export default function DownloadApp({ navigation }: RootStackScreenProps<'DownloadApp'>) {
  const windowDimensions = useWindowDimensions();

  return (
    <SnapCalorieSitePage
      headerLinks={{
        Home: () => {
          navigation.navigate('Home');
        },
      }}
    >
    <DownloadOptions maxWidth={Math.min(windowDimensions.width, 350)} />
    </SnapCalorieSitePage>
  );
}
